import * as z from "zod";

const RouteStatusEnumDto = {
    PARADA: "PARADA",
    DESPLAZAMIENTO: "DESPLAZAMIENTO",
} as const;
export type RouteStatusEnumDto =
    (typeof RouteStatusEnumDto)[keyof typeof RouteStatusEnumDto];
const RouteStatusEnumDtoSchema = z.enum(RouteStatusEnumDto);

export const ValuesDtoSchema = z.record(
    z.string(),
    z.union([z.number(), z.string().trim()]),
);
export type ValuesDto = z.output<typeof ValuesDtoSchema>;

export const TrackDtoSchema = z.object({
    timestamp: z.number(),
    status: RouteStatusEnumDtoSchema.nullable(),
    position: z.string().trim(),
    latitude: z.string().trim(),
    longitude: z.string().trim(),
    values: ValuesDtoSchema,
});
export type TrackDto = z.output<typeof TrackDtoSchema>;

export const RouteItemDtoSchema = z.object({
    tracks: z.array(TrackDtoSchema),
    roads: z.array(z.string().trim()),
});
export type RouteItemDto = z.output<typeof RouteItemDtoSchema>;

export const RouteDtoSchema = z.object({
    // eslint-disable-next-line id-denylist
    data: z.record(z.string(), RouteItemDtoSchema),
});
export type RouteDto = z.output<typeof RouteDtoSchema>;
